import React, { useEffect, useState } from "react";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";
import HeaderArea from "../components/HomeThree/HeaderArea";
import HeroSection from "../components/HomeThree/HeroSection";
import ServiceSection from "../components/HomeThree/ServiceSection";
import CaseStudyThree from "../components/HomeThree/CaseStudyThree";
import AboutUsSection from "../components/HomeThree/AboutUsSection";
import BlogWrapper from "../components/HomeThree/BlogWrapper";
import TestimonialSection from "../components/HomeThree/TestimonialSection";
import PricePlan from "../components/HomeThree/PricePlan";
import History from "../components/HomeThree/History";
import TeamMembers from "../components/HomeThree/TeamMembers";

function HomeThree() {
  //preloader
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Search Form */}
      <div className="search-bg-overlay" id="searchOverlay"></div>
      <div className="search-form-popup">
        <h2 className="mb-4">How can I help you, Today?</h2>
        <button
          type="button"
          className="close-btn"
          id="searchClose"
          aria-label="Close"
        >
          &times;
        </button>
        <form className="search-form">
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            id="site-search"
            name="q"
          />
          <button type="submit" className="btn btn-primary">
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
          </button>
        </form>
      </div>

      {/* Header Area*/}
      <HeaderArea />

      {/* Hero Section */}
      <HeroSection />

      {/* Service Section */}
      <ServiceSection />

      {/* About Us Section */}
      <AboutUsSection />

      {/* Case Study Three */}
      <CaseStudyThree />

      {/* Team Members */}
      <TeamMembers />

      {/* History */}
      <History />

      {/* Awards & Honors */}
      <div className="awards-honors-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="award-card-container">
                {/* Award Card */}
                <div className="award-card style-two">
                  <div className="awarded-year">2017</div>
                  <div className="award-name">
                    Commercial Award <br />
                    <span>
                      Business consulting many lawyers to offer free
                      consultations way is a professional service individuals or
                      firms with expertise
                    </span>
                  </div>
                  <div className="award-address">
                    Berlin Design Week, Germany
                  </div>
                </div>

                {/* Award Card */}
                <div className="award-card style-two">
                  <div className="awarded-year">2019</div>
                  <div className="award-name">
                    Plants & Architecture
                    <br />
                    <span>
                      Business consulting many lawyers to offer free
                      consultations way is a professional service individuals or
                      firms with expertise
                    </span>
                  </div>
                  <div className="award-address">
                    Architecture Week, Rome, Italy
                  </div>
                </div>

                {/* Award Card */}
                <div className="award-card style-two">
                  <div className="awarded-year">2019</div>
                  <div className="award-name">
                    Motion Graphics
                    <br />
                    <span>
                      Business consulting many lawyers to offer free
                      consultations way is a professional service individuals or
                      firms with expertise
                    </span>
                  </div>
                  <div className="award-address">London Design Week, UK</div>
                </div>

                {/* Award Card */}
                <div className="award-card style-two">
                  <div className="awarded-year">2019</div>
                  <div className="award-name">
                    Plan Roof
                    <br />
                    <span>
                      Business consulting many lawyers to offer free
                      consultations way is a professional service individuals or
                      firms with expertise
                    </span>
                  </div>
                  <div className="award-address">
                    Berlin Design Week, Germany
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {/* Price Plan */}
      <PricePlan />

      {/* Testimonial Section */}
      <TestimonialSection />

      {/* Blog Wrapper */}

      <BlogWrapper />

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default HomeThree;
